/**
 * Hosted assistants (Claude, ChatGPT) connect by signing in to Rithmo (OAuth), not with a token. Their connection journey
 * is shown only in a build that turns it on (VITE_HOSTED_CONNECTORS=on) for live acceptance on an environment where the
 * sign-in is configured; everywhere else they are shown as not available yet.
 */
export const hostedConnectors = (): boolean => import.meta.env.VITE_HOSTED_CONNECTORS === 'on'

/** Normalize an MCP URL against the public origin (RR-3). An EXTERNAL agent (Claude/ChatGPT) needs the ABSOLUTE https
 *  origin — a relative configured value (e.g. `/api/mcp`) is combined with the current origin; an absolute value is used
 *  as-is; unset falls back to this API's own origin. Pure + exported for testing. */
export const normalizeMcpUrl = (configured: string | undefined, apiOrigin: string): string => {
  const c = configured?.trim()
  if (!c) return `${apiOrigin}/api/mcp`
  if (/^https?:\/\//i.test(c)) return c
  return `${apiOrigin}${c.startsWith('/') ? '' : '/'}${c}`
}

/** The MCP address agents use: the deployment's public one, normalized to an absolute URL at this origin. */
export const publicMcpUrl = (apiOrigin: string): string => normalizeMcpUrl(import.meta.env.VITE_PUBLIC_MCP_URL, apiOrigin)
